import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import SendSiteNoticeButton from '../components/SendSiteNoticeButton';
import StudentMessageThread from '../components/StudentMessageThread';

export default function TeacherMessagesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [threads, setThreads] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const studentId = searchParams.get('student_id') || '';

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/messaging/teacher/threads/');
        if (cancelled) return;
        const list = res.data?.threads || [];
        setThreads(list);
        setSearchParams((prev) => {
          if (prev.get('student_id') || list.length !== 1) return prev;
          const next = new URLSearchParams(prev);
          next.set('student_id', String(list[0].student_id));
          return next;
        }, { replace: true });
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.detail || 'Не удалось загрузить переписку');
          setThreads([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [setSearchParams]);

  const active = threads.find((t) => String(t.student_id) === String(studentId));

  return (
    <div className="sched-page">
      <div className="page-header">
        <h1>Сообщения</h1>
        <p className="page-subtitle">
          Организационная лента с учениками. Перенос и отмена — в{' '}
          <Link to="/teacher/schedule">расписании</Link>.
        </p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {loading && <p>Загрузка…</p>}

      {!loading && threads.length === 0 && (
        <p className="muted">Нет активных учеников для переписки.</p>
      )}

      {!loading && threads.length > 0 && (
        <div className="ops-messages-layout">
          <aside className="ops-messages-aside">
            <ul className="ops-thread-picker">
              {threads.map((t) => (
                <li key={t.student_id}>
                  <button
                    type="button"
                    className={
                      String(t.student_id) === String(studentId)
                        ? 'ops-thread-picker-item is-active'
                        : 'ops-thread-picker-item'
                    }
                    onClick={() => setSearchParams({ student_id: String(t.student_id) })}
                  >
                    <span className="ops-thread-picker-copy">
                      <span>{t.student_name}</span>
                      {t.last_message?.body && (
                        <span className="ops-thread-picker-preview">{t.last_message.body}</span>
                      )}
                    </span>
                    {t.unread_count > 0 && (
                      <span className="badge">{t.unread_count}</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </aside>
          <div className="ops-messages-main">
            {active ? (
              <>
                <p className="ops-notice-toolbar">
                  <SendSiteNoticeButton
                    studentId={Number(active.student_id)}
                    studentName={active.student_name}
                  />
                </p>
                <StudentMessageThread
                  mode="teacher"
                  studentId={Number(active.student_id)}
                  studentName={active.student_name}
                />
                <p className="muted">
                  <Link to={`/teacher/students/${active.student_id}`}>
                    К работам ученика
                  </Link>
                </p>
              </>
            ) : (
              <p className="muted">Выберите ученика слева.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
